import React from "react";
import "../../styles/Footer.css";

function Footer() {
return(    
<footer className="footer">
    <div className="bottom">Clicky Game! 
      <img alt="react" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/800px-React-icon.svg.png"/>
    </div>
</footer>)
}

export default Footer;